import Vue from 'vue'

const Id = function () {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return '_' + Math.random().toString(36).substr(2, 9);
}

export default {
	state: {
		allProducts: [],//all products
		products : [],//company products
		advancedFeatures: [
			{text: 'positioning tracker', unitCost: 9, investments: 100, time: 1},
			{text: 'power bank', unitCost: 11, investments: 120, time: 1.5},
			{text: 'missed items warning', unitCost: 7, investments: 220, time: 1},
			{text: 'danger alarm', unitCost: 8, investments: 210, time: 1.5},
			{text: 'fridge camera', unitCost: 14, investments: 190, time: 2},
			{text: 'against loss insurance', unitCost: 2, investments: 30, time: 1},
			{text: 'environment friendly utilization', unitCost: 3, investments: 40, time: 2},
			{text: 'charity profit sharing', unitCost: 1, investments: 0, time: 0},
			{text: 'individual pictures', unitCost: 18, investments: 300, time: 2},
		],
		unitCost: [
			{material: 5.8, manufacturing: 4.4},
			{material: 6.1, manufacturing: 5.1},
			{material: 6.5, manufacturing: 6.0},
			{material: 6.9, manufacturing: 6.9},
			{material: 7.5, manufacturing: 7.5}
		],
		rdInvestments: [
			{designLevel: 700, material: 50, manufacturing: 190},
			{designLevel: 770, material: 70, manufacturing: 250},
			{designLevel: 860, material: 90, manufacturing: 370},
			{designLevel: 1090, material: 140, manufacturing: 480},
			{designLevel: 1290, material: 200, manufacturing: 600}
		],
		rdTime: [
			{designLevel: 1.5, material: 0.5, manufacturing: 0.5},
			{designLevel: 2, material: 0.5, manufacturing: 1},
			{designLevel: 2.5, material: 0.5, manufacturing: 1.5},
			{designLevel: 3, material: 0.5, manufacturing: 2},
			{designLevel: 3.5, material: 0.5, manufacturing: 2.5}
		]
	},
	mutations: {
		loadProducts (state, payload) {
			state.products = payload
		},
		loadAllProducts (state, payload) {
			state.allProducts = payload
		},
		addModel (state, payload) { 
			const brand = state.products.find(b => {
				return b.id === payload.brandId
			});
			const index = brand.models.length
			Vue.set(brand.models, index, payload.model)  
		},
		addBrand (state, payload) { 
			const index = state.products.length
			Vue.set(state.products, index, payload)
		},
		changeModel (state, payload) {
			const brand = state.products.find(b => {
				return b.id === payload.id
			})
			const model = brand.models.find(m => {
				return m.modelId === payload.model.modelId
			})
			
			Vue.set(brand.models, brand.models.indexOf(model), payload.model)  
		},
		deleteModel (state, payload) {
			const modelsArr = []
			for (let key in payload.models) {
				const model = payload.models[key]			
				modelsArr.push({
					modelId: key,
					model: model.model,
					material: model.material,
					manufacturing: model.manufacturing,
					designType: model.designType,
					designLevel: model.designLevel,
					variations: model.variations,
					availablefrom: model.availablefrom,
					availabletill: model.availabletill,
					unitCost: model.unitCost,
					investments: model.investments,
					advancedFeature: model.advancedFeature || '',
					parentModel: model.parentModel || '',
					salesPlan: model.salesPlan || 0,
					productionPlan: model.productionPlan || 0,
					retailPrice: model.retailPrice || 0,
					price: model.price || 0		
				})
			}
			const brand = state.products.find(b => {
				return b.id === payload.id
			})
			Vue.set(brand,'models', modelsArr)  
		},
		deleteBrand(state, payload) {
			state.products = state.products.filter(prod => prod.id != payload)
		}
	},
	actions: {
		async fetchProducts ({commit, getters}, payload=null) {
			commit('clearError')
			commit('setLoading', true)
			const resArr = []

			let gameId = 'game'
			let round = 'round'
			let company = ''

			if (payload) {
				gameId+= payload.gameId
				round+= payload.round
				company = payload.company
			}
			else {
				gameId += getters.gameId
				round += getters.currentRound
				company = getters.company
			}

			try {
				const products = await Vue.$db.collection(gameId).doc(round).collection('products')
				.where("company", "==", company)
				.get()

				if (products) {
					products.forEach(doc => {
						
						const product = doc.data()
						const modelsArr = []
						
						for (let key in product.models) {
					
							const model = product.models[key]
							
							modelsArr.push({
								modelId: key,
								model: model.model,
								material: model.material,
								manufacturing: model.manufacturing,
								designType: model.designType,
								designLevel: model.designLevel,
								variations: model.variations,
								availablefrom: model.availablefrom,
								availabletill: model.availabletill,
								unitCost: model.unitCost,
								investments: model.investments,
								inventories: model.inventories || 0,
								advancedFeature: model.advancedFeature || '',
								salesPlan: model.salesPlan || 0,
								productionPlan: model.productionPlan || 0,
								retailPrice: model.retailPrice || 0,
								price: model.price || 0
							})
						}
						resArr.push({
							id: doc.id,
							trademark: product.trademark,
							models: modelsArr
						})
					})
					commit('loadProducts', resArr)
				}
				//no products
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		//all products
		async fetchAllProducts ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)
			const resArr = []

			let gameId = 'game'+ payload.gameId
			let round = 'round'+ payload.round

			try {
				const products = await Vue.$db.collection(gameId).doc(round).collection('products')
				.get()

				if (products) {
					products.forEach(doc => {
						
						const product = doc.data()
						const modelsArr = []
						
						for (let key in product.models) {
					
							const model = product.models[key]
							
							modelsArr.push({
								modelId: key,
								model: model.model,
								material: model.material,
								manufacturing: model.manufacturing,
								designType: model.designType,
								designLevel: model.designLevel,
								variations: model.variations,
								availablefrom: model.availablefrom,
								availabletill: model.availabletill,
								unitCost: model.unitCost,
								investments: model.investments,
								inventories: model.inventories || 0,
								advancedFeature: model.advancedFeature || '',
								salesPlan: model.salesPlan || 0,
								productionPlan: model.productionPlan || 0,
								retailPrice: model.retailPrice || 0,
								price: model.price || 0
							})
						}
						resArr.push({
							id: doc.id,
							trademark: product.trademark,
							company: product.company,
							models: modelsArr
						})
					})
					commit('loadAllProducts', resArr)
				}
				//no products
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		//for next year
		async addProduct ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			
			const prod = payload.product
			const models = {}
			
			prod.models.forEach(model => {
				const modelId = model.modelId
				delete model.modelId
				models[modelId] = model
			})

			const id = payload.product.id
			delete payload.product.id

			try {
				await Vue.$db.collection(gameId).doc(round).collection('products')
				.doc(id)
				.set({
					trademark: prod.trademark,
					company: prod.company,
					models: models
				})
					
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async addModel ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			const id = payload.brandId
			const modelId = Id()
			
			try {
				const productRef = await Vue.$db.collection(gameId).doc(round).collection('products').doc(id)
				await productRef.set({
						models: {[modelId]: payload.model}
						}, { merge: true })

				//add modelId
				payload.model.modelId = modelId
				
				commit('setLoading', false)
				commit('addModel', {brandId: id, model: payload.model})
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async addBrand ({commit}, payload) {
			
			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			const modelId = Id()
			const productId = `${payload.company }-${payload.brand.trademark}`

			const model = {
				model: payload.brand.model,
				material: payload.brand.material,
				manufacturing: payload.brand.manufacturing,
				designLevel: payload.brand.designLevel,
				designType: payload.brand.designType,
				availablefrom: payload.brand.availablefrom,
				availabletill: payload.brand.availabletill,
				investments: payload.brand.investments,
				variations: payload.brand.variations,
				unitCost: payload.brand.unitCost
			}

			try {
				await Vue.$db.collection(gameId).doc(round).collection('products')
				.doc(productId)
				.set({
					trademark: payload.brand.trademark,
					company: payload.company,
					models: { [modelId]: model }
				})
				//add 
				model.modelId = modelId

				const brand = {
					'trademark': payload.brand.trademark,
					'id': productId,
					'models': [model]
				}
				commit('setLoading', false)
				commit('addBrand', brand)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async changeModel ({commit}, payload) {

			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			const id = payload.brandId
			const modelId = payload.model.modelId

			delete payload.model.modelId

			try {
				const productRef = await Vue.$db.collection(gameId).doc(round).collection('products')
				.doc(id)

				await productRef.set({
						models: {[modelId]: payload.model}
						}, { merge: true })

				payload.model.modelId = modelId

				commit('setLoading', false)
				commit('changeModel', {model:payload.model, id: id})
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async deleteModel ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			const id = payload.id
			
			try {
				const productRef = await Vue.$db.collection(gameId).doc(round).collection('products').doc(id)
				await productRef.update({ models: payload.models })

				commit('setLoading', false)
				commit('deleteModel', {id:id, models: payload.models})
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async deleteBrand ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			const id = payload.id
			
			try {
				await Vue.$db.collection(gameId).doc(round).collection('products').doc(id).delete()

				commit('setLoading', false)
				commit('deleteBrand', id)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		}
	},
	getters: {
		allProducts (state) {
			return state.allProducts
		},
		products (state) {
			return state.products
		},
		advancedFeatures (state) {
			return state.advancedFeatures
		},
		unitCost (state) {
			return state.unitCost
		},
		rdInvestments (state) {
			return state.rdInvestments
		},
		rdTime (state) {
			return state.rdTime
		},
		trademarks (state) {
			const brands = []
			state.products.forEach(prod => {
				brands.push({
					name: prod.trademark,
					brandId: prod.id
				})
			})
			return brands
		},
		allTrademarks (state) {
			const brands = []
			state.allProducts.forEach(prod => {
				brands.push({
					name: prod.trademark,
					brandId: prod.id
				})
			})
			return brands
		},
		models (state) {
			const models = []
			state.products.forEach(product => {
				product.models.forEach(model => {
					models.push(model)
				}) 
			})	
			return models
		}

	}
}